import React, { useContext, useEffect, useState } from 'react';
import { Context as Auth } from '../../../services/auth/AuthContext';
import { Button, Table } from 'antd';
import { useNavigate } from 'react-router-dom';
import { PlusOutlined } from '@ant-design/icons';
import Spinner from '../../../components/navigation/Spinner';
import '../../../components/layout/layout.css';
import { getCenterByQuery, getCenterById } from '../../../services/center.service';
import { getDeviceByQuery } from '../../../services/device.service';
import TagExercise from '../../../components/tags/TagExercise';
import { getIdToken } from 'firebase/auth';
import { useTranslation } from 'react-i18next';
import { capitalize, capitalizeAll } from '../../../utils/utils';

const Devices = (props) => {
  const { user } = useContext(Auth);
  const navigate = useNavigate();
  const [devices, setDevices] = useState(null);
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();

  useEffect(() => {
    if (user.account) {
      if (user.account.roles.indexOf('organizer') >= 0) {
        loadCenter();
      } else if (user.account.roles.indexOf('trainer') >= 0) {
        loadCenterId();
      }
    }
  }, [user.account]);

  const loadDevices = async (centerId) => {
    const { status, data } = await getDeviceByQuery({ center: centerId, isActive: true }, user.token);
    if (status === 200) {
      data.data.forEach(device => {
        device.key = device._id;
      });
      setDevices(data.data);
      setLoading(false);
    }
  };

  const loadCenter = async () => {
    const { status, data } = await getCenterByQuery({ organizer: user.account._id }, user.token);
    if (status === 200) {
      loadDevices(data.data[0]._id);
    }
  };

  const loadCenterId = async () => {
    const { status, data } = await getCenterById(user.account.center, user.token);
    if (status === 200) {
      loadDevices(data.data._id);
    }
  };

  const columns = [
    {
      title: capitalize(t('devices')),
      // dataIndex: ['name', 'surname', 'email', 'phone'],
      key: 'all',
      // eslint-disable-next-line react/display-name
      render: (record) => (
        <React.Fragment>
          {record.name}
          <br />
          {record.identifier}
          <br />
          {record.exercises.length
            ? (
              record.exercises.map((exercise) => {
                return (
                  <TagExercise key={exercise} id={exercise} user={user} token={user.token} />
                );
              })
            )
            : (<>{capitalize(t('noExercises'))}</>)}
        </React.Fragment>
      ),
      sorter: {
        compare: (a, b) => a.name.localeCompare(b.name),
        multiple: 5
      },
      responsive: ['xs']
    },
    {
      title: capitalize(t('id')),
      dataIndex: ['identifier'],
      key: 'identifier',
      render: (text, record) => record.identifier,
      sorter: {
        compare: (a, b) => a.identifier.localeCompare(b.identifier),
        multiple: 1
      },
      responsive: ['sm']
    },
    {
      title: capitalize(t('name')),
      dataIndex: ['name'],
      key: '_id',
      render: (text, record) => record.name,
      sorter: {
        compare: (a, b) => a.name.localeCompare(b.name),
        multiple: 4
      },
      responsive: ['sm']
    },
    {
      title: capitalize(t('exercises')),
      // dataIndex: ['name', 'surname', 'email', 'phone'],
      key: 'all',
      // eslint-disable-next-line react/display-name
      render: (record) => (
        <React.Fragment>
          {record.exercises.length
            ? (
              record.exercises.map((exercise) => {
                return (
                  <TagExercise key={exercise} id={exercise} user={user} token={user.token}/>
                );
              })
            )
            : (<>{capitalize(t('noExercises'))}</>)}
        </React.Fragment>
      ),
      responsive: ['sm']
    },
    {
      title: capitalizeAll(t('maxWeight')),
      dataIndex: 'maxWeight',
      key: 'maxWeight',
      sorter: {
        compare: (a, b) => a.maxWeight.localeCompare(b.maxWeight),
        multiple: 3
      },
      responsive: ['sm']
    },
    {
      title: capitalizeAll(t('minWeight')),
      dataIndex: 'minWeight',
      key: 'minWeight',
      sorter: {
        compare: (a, b) => a.minWeight.localeCompare(b.minWeight),
        multiple: 2
      },
      responsive: ['sm']
    }
  ];

  function onChange (pagination, filters, sorter, extra) {

  }

  if (loading) {
    return (
      <Spinner/>
    );
  } else {
    return (
      <>
        <Button type="primary" shape="round" icon={<PlusOutlined />} size='large' onClick={() => navigate('add')} style={{ marginBottom: 18 }}>
          {capitalize(t('createNewDevice'))}
        </Button>
        <Table columns={columns} dataSource={devices} onChange={onChange} onRow={(record, rowIndex) => {
          return {
            onClick: event => { navigate('edit/' + record._id); }, // click row
            onDoubleClick: event => {}, // double click row
            onContextMenu: event => {}, // right button click row
            onMouseEnter: event => {}, // mouse enter row
            onMouseLeave: event => {} // mouse leave row
          };
        }} rowClassName={'row-pointer'}
        />
        <br />
      </>
    );
  };
};

export default Devices;
